import { observer } from 'mobx-react-lite';
import { Moon, Sun } from 'lucide-react';
import { themeStore } from '../../stores';

const ThemeSwitcher = observer(() => {
	const handleToggle = () => {
		themeStore.toggleTheme();
	};

	return (
		<button
			onClick={handleToggle}
			className="relative inline-flex items-center justify-center w-10 h-10 rounded-[5px] border border-border hover:border-border transition-all duration-200 ease-in-out hover:bg-muted focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50"
			aria-label={`Switch to ${themeStore.isDark ? 'light' : 'dark'} mode`}
			title={`Switch to ${themeStore.isDark ? 'light' : 'dark'} mode`}
		>
			<div className="relative w-5 h-5">
				{/* Sun icon - visible in dark mode */}
				<Sun
					className={`absolute inset-0 w-5 h-5 transition-all duration-300 ease-in-out ${
						themeStore.isDark ? 'rotate-0 scale-100 opacity-100' : 'rotate-90 scale-0 opacity-0'
					} text-foreground`}
				/>

				{/* Moon icon - visible in light mode */}
				<Moon
					className={`absolute inset-0 w-5 h-5 transition-all duration-300 ease-in-out ${
						themeStore.isLight ? 'rotate-0 scale-100 opacity-100' : '-rotate-90 scale-0 opacity-0'
					} text-foreground`}
				/>
			</div>
		</button>
	);
});

ThemeSwitcher.displayName = 'ThemeSwitcher';

export default ThemeSwitcher;
